
<div>
  <!-- Titre Main -->
  <Titre
    v-if="content.libTitreSection"
    :content="{
      titre: content.libTitreSection,
      type: 'grandTitre pt-0 pb-3 mb-0',
    }"
    class="title-secondary title-main"
  ></Titre>
  <!-- Description Main -->
  <Paragraphe
    v-if="content.libSousTitreSection"
    :content="{
      richText: content.libSousTitreSection,
      classeCSS: 'pb-0',
    }"
    class="texte-desc"
  ></Paragraphe>
  <!-- Section Depot Semaines -->
  <section class="section-depot-semaines">
    <LimiteDepotChoix
      :category="categories[0]"
      :period="period"
      :content="content"
      :title="content.titreDeposit"
      :texte="content.descriptionDeposit"
      :initialValue="limits[categories[0]] || null"
      @confirm-changed="handleConfirmChanged"
    />
  </section>
  <!-- Section limite temps et pertes -->
  <section v-show="showSection" class="section-outils">
    <div class="section-outils-grey">
      <!-- Titre Main -->
      <Titre
        v-if="content.libTitreSectionOutils"
        :content="{
          titre: content.libTitreSectionOutils,
          type: 'titre pt-0 pb-1 mb-0',
        }"
        class="title-secondary title-main"
      ></Titre>
      <!-- Description Main -->
      <Paragraphe
        v-if="content.libSousTitreSectionOutils"
        :content="{
          richText: content.libSousTitreSectionOutils,
          classeCSS: 'pb-1',
        }"
        class="texte-desc"
      ></Paragraphe>
      <div
        v-for="(item, index) in outilsSections"
        :key="item.category"
        :class="item.containerClass"
      >
        <LimiteDepotChoix
          :category="item.category"
          :period="period"
          :content="content"
          :title="item.title"
          :texte="item.text"
          :initialValue="limits[item.category] || null"
          @show-message="handleShowMessage"
        />
      </div>
      <Paragraphe
        v-if="content.txtDelaisWeek"
        :content="{
          richText: content.txtDelaisWeek,
          classeCSS: 'pt-1 note',
        }"
        class="texte-legal"
      ></Paragraphe>
    </div>
  </section>
  <!-- Message Avertissement -->
  <div v-show="showConfirmBtn">
    <div
      v-if="content.txtWarningMessage"
      class="warning-box"
      v-html="content.txtWarningMessage"
    ></div>
  </div>
  <div class="btn-right">
    <button
      type="button"
      class="btn btn-next px-6 mb-0 btn-primaire"
      :disabled="!isConfirmed"
      tabindex="0"
      @click="nextDepot"
    >
      <span>{{ content.libBtnFormNext }}</span>
    </button>
  </div>
</div>
